module.exports = __webpack_public_path__ + "static/media/994185.0b2c1973.png";